import { Column, Entity, OneToMany, PrimaryColumn } from "typeorm";

import { SubjectModelDetail } from "../../_objects/subject-model";
import { TenantIdSchemaBase } from "../interfaces/tenantId.base";
import { SubjectSchema } from "./subject.schema";
import { SubjectModelLocationsSchema } from "./subjectModel-locations.schema";

/**
 * SubjectModelSchema インターフェイス。
 */
export interface ISubjectModelSchema {
  id: string;
  name: string;
  structImageFilePath: string;
  lastUpdateDate: string;
  isValid: boolean;
  tenantId: string;
  isDeleted: boolean;
  subjects: SubjectSchema[];
  subjectModelLocations: SubjectModelLocationsSchema[];
  /** オフラインで作成したかどうか。 */
  isOfflineData: boolean;
}

@Entity()
export class SubjectModelSchema implements TenantIdSchemaBase, ISubjectModelSchema {
  @PrimaryColumn()
  id: string;

  @Column({ nullable: true, length: 100 })
  name: string | null;

  @Column({ nullable: true })
  structImageFilePath: string | null;

  @Column({ nullable: true })
  lastUpdateDate: string | null;

  @Column()
  isValid: boolean;

  @Column({ nullable: true })
  tenantId: string | null;

  @Column({ nullable: true })
  isDeleted: boolean | null;

  @Column({ nullable: true })
  isOfflineData: boolean | null;

  // relations

  @OneToMany("SubjectSchema", "subjectModel")
  subjects: SubjectSchema[];

  @OneToMany("SubjectModelLocationsSchema", "subjectModel")
  subjectModelLocations: SubjectModelLocationsSchema[];

  /**
   * コンストラクター。
   *
   * @param subjectModelDetail SubjectModelDetail。
   * @param tenantId テナント ID。
   * @param extractStructImagePath URL から抽出した structImageFilePath。未指定の場合は subjectModelDetail.structImagePath を使用する。
   */
  constructor(subjectModelDetail?: SubjectModelDetail, tenantId?: string, extractStructImagePath?: string) {
    if (subjectModelDetail) {
      this.id = subjectModelDetail.id;
      this.name = subjectModelDetail.name;
      this.structImageFilePath = subjectModelDetail.structImagePath;
      this.lastUpdateDate = subjectModelDetail.lastUpdateDate;
      this.isValid = subjectModelDetail.isValid;
      this.isDeleted = subjectModelDetail.isDeleted;
      this.isOfflineData = subjectModelDetail.isOfflineData;
    }

    if (tenantId) {
      this.tenantId = tenantId;
    }

    if (extractStructImagePath) {
      this.structImageFilePath = extractStructImagePath;
    }
  }
}

export class SubjectModelSchemaQueryOpt {
  tenantId: string;
  enabledOnly: boolean;
  aliveOnly: boolean;

  constructor(tenantId: string, enabledOnly: boolean, aliveOnly: boolean) {
    this.tenantId = tenantId;
    this.enabledOnly = enabledOnly;
    this.aliveOnly = aliveOnly;
  }
}
